module.exports = __webpack_public_path__ + "img/icon_live.47e923eb.png";